import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import { getWalletsSkeleton } from '../../initData';
import css from './OfficeWallets.module.scss';
import { getBreakpoint } from '../../../../widgets/plug/Skeleton/components/patterns';
import { getData } from '../../../../common/utils/router';
import UserContext from '../../../../common/utils/getContext';
import Wallets from '../../../../widgets/wallets/Wallets';

const RenderData = ({ financeAccounts, setNewFindedCurrency }) => {
    const wallets = financeAccounts?.data;
    if (!wallets) return null;
    return (
        <div className={css.officeWallets}>
            <Wallets meta={financeAccounts?.meta} wallets={wallets} toggleCurr={setNewFindedCurrency} />
        </div>
    );
};
const OfficeWallets = (props) => {
    const { userToken, lang } = useContext(UserContext);
    const [newFindedCurrency, setNewFindedCurrency] = useState(false);
    const [financeAccounts, setFinanceAccounts] = useState(null);
    const breakpoint = getBreakpoint(useWindowDimensions(true));
    const skeleton = getWalletsSkeleton(breakpoint);

    const transformFinanceAccounts = useCallback((accounts) => {
        return accounts
            ?.sort((account1) => {
                if (account1.purpose === 'bonus') return 1;
                return -1;
            })
            .map((account) => ({
                ...account,
                name: account.name.replace(' PV', '')
            }))
            .filter((account) => account.purpose != 'gift');
    }, []);

    useEffect(() => {
        getData('/api/v1/user/finance/accounts', userToken, lang, false, newFindedCurrency || 'PV')
            .then((res) =>
                setFinanceAccounts({
                    ...res,
                    data: transformFinanceAccounts(res?.data)
                })
            )
            .catch(console.warn);
    }, [userToken, lang, newFindedCurrency, transformFinanceAccounts]);

    return (
        <div className={css.walletsWrap}>
            <Skeleton
                wrapperStyles={css.skeleton}
                itemsShiners={true}
                Component={RenderData}
                wait={Boolean(financeAccounts)}
                lazy={true}
                componentProps={{
                    ...props,
                    financeAccounts,
                    setNewFindedCurrency
                }}
                elements={skeleton}
            />
        </div>
    );
};
export default OfficeWallets;
